import HeaderScrolled from '../../helper/header-scrolled';
import ScrollTo from '../../helper/scroll-to';

const ContactPage = {
  init() {
    this._scrollToInit();
    this._headerScrolledInit();
  },


  _scrollToInit() {
    ScrollTo.init();
  },


  _headerScrolledInit() {
    HeaderScrolled.init();
  }
};

export default ContactPage;